module.exports = __webpack_public_path__ + "static/media/forgot-username-ic.688f15e2.svg";